import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { components } from 'react-select';
import Link from '../../../typography/Link';
import Icon from '../../../general/Icon';
import Text from '../../../typography/Text';
import { useTheme } from '../../../../utils/styles';
export default /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const theme = useTheme();
  const {
    className,
    actionContainerClassName,
    actionClassName,
    actionIconClassName,
    actionTextClassName,
    actionTextWithIconClassName,
    override,
    actions,
    onClickAction,
    dropdownWidth
  } = props.selectProps.menuProps;
  const linkRow = useCallback((action, index) => {
    if (action.component) {
      const onClick = action.onClick ? () => {
        onClickAction && onClickAction(action);
        action.onClick && action.onClick();
      } : null;
      return /*#__PURE__*/React.createElement("div", _extends({
        key: index,
        className: actionClassName
      }, override.action, {
        onClick: onClick
      }), action.component);
    }
    const icon = action.icon;
    const iconType = action.iconType;
    let finalIcon;
    if (icon) finalIcon = icon;else if (iconType) finalIcon = /*#__PURE__*/React.createElement(Icon, {
      name: iconType,
      color: theme.colors.actionMajor[500]
    });
    let textClasses = [actionTextClassName];
    let textOverride = {
      ...override.actionText
    };
    if (finalIcon) {
      textClasses = [actionTextWithIconClassName];
      textOverride = {
        ...textOverride,
        ...override.actionTextWithIcon
      };
    }
    return /*#__PURE__*/React.createElement("div", _extends({
      className: actionClassName,
      key: index
    }, override.action, {
      onClick: () => {
        onClickAction && onClickAction(action);
        action.onClick && action.onClick();
      }
    }), finalIcon && /*#__PURE__*/React.createElement("div", _extends({
      className: actionIconClassName
    }, override.actionIcon), finalIcon ? finalIcon : null), /*#__PURE__*/React.createElement("div", _extends({
      className: textClasses
    }, textOverride), action.isLink && /*#__PURE__*/React.createElement(Link, null, action.label), !action.isLink && /*#__PURE__*/React.createElement(Text, {
      color: theme.colors.actionMajor[500],
      type: "subtitle"
    }, action.label)));
  }, [actionTextClassName, override.actionText, override.action, override.actionIcon, override.actionTextWithIcon, actionClassName, actionIconClassName, actionTextWithIconClassName, onClickAction, theme]);
  const innerProps = useMemo(() => {
    if (dropdownWidth) return {
      ...props.innerProps,
      style: {
        width: dropdownWidth
      }
    };
    return props.innerProps;
  }, [dropdownWidth, props]);
  return components.Menu && /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
    className: className,
    innerProps: innerProps
  }, override.menu), children, actions && /*#__PURE__*/React.createElement("div", _extends({
    className: actionContainerClassName
  }, override.actionContainer), actions.map((action, idx) => linkRow(action, idx))));
});